export default {
  getExpenseLineItem: (state) => state.expenseLineItem,
};
